import api from '../../config/AxiosService';
import { Inference, Training } from '../../types';

export const getTrainingList = async (modelId: number): Promise<Training[]> => {
  const response = await api.get(`/trainings/list/${modelId}`);
  return response.data;
};

export const getTrainingListStatus = async (modelId: number): Promise<{ [id: string]: string }> => {
  const response = await api.get(`/trainings/list/${modelId}/status`);
  return response.data;
};

export const getTrainingInferenceList = async (trainingId: string): Promise<Inference[]> => {
  const response = await api.get(`/trainings/${trainingId}/inference-list`);
  return response.data;
};

export const createTraining = async (
  modelId: number,
  inferenceIds: string[],
  modelVersionName: string
): Promise<Training> => {
  const { data } = await api.post(
    '/trainings/create-training',
    {
      modelId,
      inferenceIds,
      modelVersionName,
    },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );

  return data;
};

export const startTraining = async (trainingId: string) => {
  const { data } = await api.post(`/trainings/${trainingId}/start`, {});
  return data;
};

export const getTraining = async (trainingId: string): Promise<Training> => {
  const { data } = await api.get(`/trainings/${trainingId}`);
  return data;
};

export const deleteTraining = async (trainingId: string) => {
  await api.delete(`/trainings/${trainingId}`);
};
